import { Component, ChangeDetectionStrategy, Input, inject } from '@angular/core';
import { PlainLink, AspectRatio, ColumnWidth, Breakpoint, greater, lower, DEVICE_TYPE_SERVICE_TOKEN } from '@knorr-bremse-portals/ngx-components';
import { PictureComponent, PictureSources, PictureVariants } from '@knorr-bremse-portals/ngx-components/components/picture';
import { HeadingLevel } from '@knorr-bremse-portals/ngx-components/components/variable-heading';
import { AbstractMode, OverlayFigureComponent } from '@knorr-bremse-portals/ngx-components/components/overlay-figure';

@Component({
  selector: 'kb-hero-picture',
  templateUrl: './hero-picture.component.html',
  styleUrls: ['./hero-picture.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ OverlayFigureComponent, PictureComponent ],
})
export class HeroPictureComponent {
  @Input() public variants?: PictureVariants;
  @Input({ required: true }) public picture!: PictureSources;
  @Input({ required: true }) public alt!: string;
  @Input({ required: true }) public rootColumns!: ColumnWidth;
  @Input() public heading?: string;
  @Input() public headingLevel: HeadingLevel = 2;
  @Input() public abstract?: string;
  @Input() public link?: PlainLink;
  @Input() public aboveFold = true;
  @Input() public indented = true;
  @Input() public largeHeading = true;
  @Input() public abstractMode: AbstractMode = 'visible';

  protected isMobile = inject(DEVICE_TYPE_SERVICE_TOKEN).isMobile() === true;

  protected fallbackVariants: PictureVariants = [
    {
      aspectRatio: AspectRatio.Standard,
      mediaQuery: lower(Breakpoint.MediumSmall),
    },
    {
      aspectRatio: AspectRatio.Wide,
      mediaQuery: greater(Breakpoint.MediumSmall),
    },
    {
      aspectRatio: this.isMobile ? AspectRatio.Standard : AspectRatio.Wide,
    },
  ]
}
